import React, { useState } from "react"
import PropTypes from "prop-types"

import { getAssetPath, sanitizer } from "@commonUtils"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import css from "./Accordion.scss"

const SUBTEXT_COLOR = {
    normal: "subTextNormal",
    error: "subTextError",
    caution: "subTextCaution",
    success: "subTextSuccess",
}

const fontWeight = {
    medium: "bodyMedium",
    semiBold: "bodySemiBold",
    l5Medium: "l5Medium",
}

function NewAccordion(props) {
    const [active, setActive] = useState(props.active)

    const toggleAccordion = () => {
        setActive(!active)
        if (props.onClick) {
            props.onClick(!active)
        }
    }

    return (
        <div className="flexColumn">
            <button
                aria-expanded={active}
                aria-controls={props.title}
                className={`flex alignCenter ${props.className} ${css.toggleContainer} ${css.accordionButton}`}
                onClick={toggleAccordion}
            >
                {props.image && props.image?.url && (
                    <div className={css.marginRight}>
                        <ImageLoader
                            src={props.image.url}
                            width={props.image.width}
                            height={props.image.height}
                            alt={props.image.altText}
                        />
                    </div>
                )}
                <div className={`flex justifyBetween ${css.containerWidth}`}>
                    <div className={`flexColumn ${fontWeight[props.size]}`}>
                        <span
                            className={css.title}
                            dangerouslySetInnerHTML={{ __html: sanitizer(props.title) }}
                        />

                        {props.subText && (
                            <div className={`smallRegular ${css[SUBTEXT_COLOR[props.subtextStatus]]}`}>
                                {props.subText}
                            </div>
                        )}
                    </div>
                    <img
                        className={`${css.icon} ${!active && css.flipIcon}`}
                        src={getAssetPath("svgs/icons/chevron-down_18px_primary.svg")}
                        alt=" "
                        title="Accordion"
                    />
                </div>
            </button>

            {props.children && (
                <div
                    id={props.title}
                    className={`${css.content} ${!active && css.contentCollapsed} ${
                        active ? "marginTop-16" : ""
                    }`}
                >
                    {props.children}
                </div>
            )}
            <div className="marginTop-16">{props.showSweeper && <div className={`${css.sweeper}`} />}</div>
        </div>
    )
}

NewAccordion.propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        altText: PropTypes.string.isRequired,
        width: PropTypes.string.isRequired,
        height: PropTypes.string.isRequired,
    }),
    title: PropTypes.string,
    active: PropTypes.bool,
    subText: PropTypes.string,
    subtextStatus: PropTypes.oneOf(["normal", "error", "caution", "success"]),
    children: PropTypes.instanceOf(Object).isRequired,
    size: PropTypes.oneOf(["medium", "semiBold"]),
    onClick: PropTypes.func,
    showSweeper: PropTypes.bool,
    className: PropTypes.string,
}

NewAccordion.defaultProps = {
    active: false,
    subtextStatus: "normal",
    size: "medium",
    showSweeper: true,
    className: "marginTop-16",
}

export default NewAccordion
